import { Component, OnInit } from '@angular/core';
import {
  IconEnum,
  ControlSizeEnum,
  ControlTypeColorEnum,
  AvatarTypeEnum,
  DialogRef
} from 'datnek-ds';

@Component({
  selector: 'del-shared-dialog-delete-group',
  templateUrl: './dialog-delete-group.component.html',
  styleUrls: ['./dialog-delete-group.component.scss'],
})
export class DialogDeleteGroupComponent {
  iconEnum = IconEnum;
  sizeEnum = ControlSizeEnum;
  colorEnum = ControlTypeColorEnum;
  avatarEnum = AvatarTypeEnum;

  constructor(public ref: DialogRef) {}

  close() {
    this.ref.close(null);
  }
}
